/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description DeleteAttachment button component
 */
import { Button, App } from 'antd';
import { DeleteOne } from '@icon-park/react';
import useDeleteAttachment from 'hooks/claim/mutate/useDeleteAttachment';
import { MODAL_TYPES } from '../modal';

export interface IProps {
	blobId: string;
	entityType: EntityTypeEnum;
	entityId: string;
	disabled?: boolean;
}

const DeleteAttachment: React.FC<IProps> = ({ blobId, entityType, entityId, disabled }) => {
	const { mutateAsync } = useDeleteAttachment();
	const { modal } = App.useApp();
	const handleDelete = () => {
		modal.confirm({
			...MODAL_TYPES.warning,
			title: 'Delete Attachment',
			content: 'Are you sure you want to delete this attachment?',
			onOk: async () => {
				await mutateAsync({ blobId, entityType, entityId });
			},
			okText: 'Yes, delete',
			cancelText: 'Cancel',
		});
	};
	return <Button danger icon={<DeleteOne />} onClick={handleDelete} disabled={disabled} />;
};

export default DeleteAttachment;
